import * as React from "react"
import * as styles from "./styles.css"
import clsx from "clsx"

export type SpinnerProps = {
  className?: string
  hasReversedColors?: boolean
}

export function Spinner({
  className,
  hasReversedColors = false,
}: SpinnerProps) {
  return (
    <div className={clsx(styles.box, className)}>
      <div
        className={clsx(
          styles.spinner,
          hasReversedColors ? styles.reversedColors : styles.defaultColors
        )}
      />
    </div>
  )
}
